import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import Home from '../views/Home.vue'
import Code from '../views/Code.vue'
import Blog from '../views/Blog.vue'
import Contact from '../views/Contact.vue'
import BlogReader from '../views/BlogReader'
import BlogWrite from '../views/BlogWrite'
import Splash from '../views/Splash'
import Admin from '../views/Admin'

const routes = [
  {
    path: '/',
    name: 'Splash',
    component: Splash
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/code',
    name: 'Code',
    component: Code
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/blog/:id',
    name: 'BlogReader',
    component: BlogReader
  },
  {
    path: '/write',
    name: 'BlogWrite',
    component: BlogWrite
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/:catchAll(.*)',
    redirect: { name: 'Home' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) =>  {
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
  const isAdmin = store.state.admin;
  const loggedIn = store.state.loggedIn;

  console.log(`Requires: ${requiresAdmin} Is: ${isAdmin}`)

  // console.log(`to: ${to.name} from: ${from} next: ${next}`)

  await store.dispatch('setRoute', to.fullPath);

  if (!loggedIn && to.name != 'Splash') {
    next({ name: 'Splash' })
  }

  if (requiresAdmin && !isAdmin) next({ name: 'Home' })
  else next()
})

export default router
